import { Routes, RouterModule } from '@angular/router';

export const FullLayout_ROUTES: Routes = [

    {
        path: 'public-web',
        loadChildren: () => import('../../public-web/public-web-routing.module').then(m => m.PublicWebsRoutingModule)
    },

    {
        path: 'pages',
        loadChildren: () => import('../../pages/pages-routing.module').then(m => m.PagesRoutingModule)
    }
];
